module.exports = "label {\n  display: block; }\n\n.paypal-wrapper form {\n  margin-bottom: 20px; }\n\n@media (min-width: 590px) {\n    .paypal-wrapper form {\n      width: 33%;\n      float: left;\n      margin-bottom: 0; } }\n\n.paypal-wrapper form select {\n    margin: 5px 0 10px 0;\n    padding: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pay/pay.component.scss
// module id = ./src/app/pay/pay.component.scss
// module chunks = main